import Vue from 'vue';

/**
 * @typedef {Object} EntityConfig
 * @property {String} logo
 * @property {Boolean} location_number_auto_generate
 * @property {Boolean} location_require_county_municipality
 * @property {Boolean} work_visit_timecard_enable
 * @property {Boolean} enable_sub_contractors
 * @property {Boolean} enable_visit_verification
 * @property {Boolean} enable_inventory
 * @property {Boolean} enable_inventory_min_max
 * @property {Boolean} visit_complete_auto_schedule
 * @property {Boolean} enable_mandatory_service_reason
 * @property {String} work_visit_schedule_sort
 * @property {String} schedule_calendar_format
 * @property {String} schedule_week_format
 * @property {String} schedule_focused_format
 * @property {String} schedule_map_format
 * @property {Boolean} enable_user_timesheets
 * @property {Boolean} approve_customer_contacts
 * @property {Boolean} auto_number_fleet
 * @property {Boolean} require_visit_diagram
 * @property {Boolean} require_visit_verification
 * @property {Boolean} work_require_invoice_before_closing
 * @property {Boolean} work_prevent_start_date_in_past
 * @property {Boolean} work_quote_require_customer_approval
 * @property {string} work_quote_expire_time
 * @property {String} work_quote_terms
 * @property {String} invoice_notification_delay
 * @property {String} invoice_footer
 */
const config_defaults = {
    logo: null,
    location_number_auto_generate: true,
    location_require_county_municipality: false,
    work_visit_timecard_enable: false,
    enable_sub_contractors: false,
    enable_visit_verification: false,
    enable_inventory: false,
    enable_inventory_min_max: false,
    visit_complete_auto_schedule: false,
    enable_mandatory_service_reason: false,
    work_visit_schedule_sort: 'time',
    schedule_calendar_format: '#{location_number} - {customer_name}',
    schedule_week_format: '{city}',
    schedule_focused_format: '#{location_number} {customer_name}',
    schedule_map_format: '#{visit_number} - {customer_name}',
    enable_user_timesheets: false,
    require_visit_diagram: false,
    require_visit_verification: false,
    approve_customer_contacts: false,
    summary_auto_include_attachments_images: false,
    summary_auto_include_attachments_documents: false,
    work_require_invoice_before_closing: false,
    work_prevent_start_date_in_past: false,
    work_quote_require_customer_approval: false,
    work_quote_expire_time: '17:00',
    work_quote_terms: null,
    invoice_notification_delay: null,
    invoice_footer: null,
};

const config_types = {
    logo: String,
    location_number_auto_generate: Boolean,
    location_require_county_municipality: Boolean,
    work_visit_timecard_enable: Boolean,
    enable_sub_contractors: Boolean,
    enable_visit_verification: Boolean,
    enable_inventory: Boolean,
    enable_inventory_min_max: Boolean,
    visit_complete_auto_schedule: Boolean,
    enable_mandatory_service_reason: Boolean,
    work_visit_schedule_sort: String,
    schedule_calendar_format: String,
    schedule_week_format: String,
    schedule_focused_format: String,
    schedule_map_format: String,
    enable_user_timesheets: Boolean,
    auto_number_fleet: Boolean,
    require_visit_diagram: Boolean,
    require_visit_verification: Boolean,
    approve_customer_contacts: Boolean,
    summary_auto_include_attachments_images: Boolean,
    summary_auto_include_attachments_documents: Boolean,
    work_require_invoice_before_closing: Boolean,
    work_prevent_start_date_in_past: Boolean,
    invoice_notification_delay: String,
    invoice_footer: String,
    work_quote_terms: String,
};

const state = {
    configs: {
        ...config_defaults,
    },
    config_defaults: {
        ...config_defaults,
    },
};

const mutations = {
    SET_CONFIGS (state, configs) {
        // Set each config value
        configs.forEach((config) => {
            switch ( config_types[config.config_name] ) {
                case Boolean:
                    Vue.set(
                        state.configs,
                        config.config_name,
                        config.value && config.value != '0' ? true : false
                    );
                    break;
                default:
                    Vue.set(state.configs, config.config_name, config.value);
            }
        })
    },

    SET_CONFIG_VALUE (state, {config_name, value}) {
        state.configs[config_name] = value;
    }
};

import * as getters from './getters';
import * as actions from './actions';

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
